import { useReferralContext } from '../../context';
import Button from '@ramsey-design-system/button';
import { VerificationStatus } from '../../enums';

interface ResubmitButtonProps {
  onClick: () => void;
  status: VerificationStatus;
}

function getResendButtonText(
  status: VerificationStatus,
  phoneVerificationCountDown: number
) {
  if (status === VerificationStatus.resendingCode) {
    return 'Resending...';
  } else if (phoneVerificationCountDown > 0) {
    return `Resend Code in ${phoneVerificationCountDown}`;
  } else {
    return 'Resend Code';
  }
}

export function ResubmitButton({
  onClick,
  status
}: Readonly<ResubmitButtonProps>) {
  const { phoneVerificationCountDown } = useReferralContext();
  const resendButtonText = getResendButtonText(
    status,
    phoneVerificationCountDown
  );

  return (
    <Button
      data-testid="tax_resend_code_button"
      type="button"
      className="!w-full"
      iconPosition="right"
      appearance="subtle"
      fullWidthOnMobile={true}
      size="large"
      onClick={onClick}
      loading={status === VerificationStatus.resendingCode}
      disabled={
        phoneVerificationCountDown > 0 ||
        status === VerificationStatus.resendingCode ||
        status === VerificationStatus.verifyingCode ||
        status === VerificationStatus.submittingReferral
      }
    >
      {resendButtonText}
    </Button>
  );
}
